import { REQUEST } from '../../constants';

export const extractRequestTypeFromStatuses = requestTypeStatus => {
  if (!requestTypeStatus || requestTypeStatus.length === 0) {
    return null;
  }
  const [request] = requestTypeStatus[0].split('.');
  return request || null;
};

/**
 * Retainers are always handled by OrthoSelect and have no tech workflow, so the
 * assignment / on-hold / rush / batch controls do not apply to them.
 */
export const isRetainerRequestFilter = ({ requestTypeStatus } = {}) =>
  extractRequestTypeFromStatuses(requestTypeStatus) === REQUEST.RETAINER;
